import huaweiY from './assets/huaweiY.PNG';
import huawei9 from './assets/huawei9.PNG';
import iphone11Promax from './assets/iphone11Promax.PNG';
import iphone12 from './assets/iphone12.PNG';
import iphone14Promax from './assets/iphone14Promax.PNG';
import samsunga12 from './assets/samsunga12.PNG';
import samsungs20 from './assets/samsungs20.PNG';
import zflip from './assets/zflip.PNG';
import xiaomi14t from './assets/xiaomi14t.PNG';
import xiaomi9c from './assets/xiaomi9c.PNG';
import infinixhot10 from './assets/infinixhot10.PNG';
import infinixsmart6 from './assets/infinixsmart6.PNG';
import bangandolufsen from './assets/bangandolufsen.PNG';



const productsData = [
  {
    id: 1,
    title: 'Huawei nova 9',
    href: '#',
    price: '$48',
    image: huawei9,
    imageAlt: '',
    cart: 'Add to cart',
  },
  {
    id: 2,
    title: 'HuaweI Y',
    href: '#',
    price: '$35',
    image: huaweiY,
    imageAlt: '',
    cart: 'Add to cart',
  },
  {
    id: 3,
    title: 'Iphone 11 Pro max',
    href: '#',
    price: '$89',
    image: iphone11Promax,
    imageAlt: '',
    cart: 'Add to cart',
  },
  {
    id: 4,
    title: 'Iphone 14 Pro max',
    href: '#',
    price: '$35',
    image: iphone14Promax,
    imageAlt: '',
    cart: 'Add to cart',
    
  },
  {
      id: 5,
      title: 'Iphone 12',
      href: '#',
      price: '$35',
      image: iphone12,
      imageAlt: '',
      cart: 'Add to cart',
      
    },
    {
      id: 6,
      title: 'Samsung A12',
      href: '#',
      price: '$35',
      image: samsungs20,
      imageAlt: '',
      cart: 'Add to cart',
      
    },
    {
      id: 7,
      title: 'Samsung 12',
      href: '#',
      price: '$35',
      image: samsunga12,
      imageAlt: '',
      cart: 'Add to cart',
      
    },
    {
      id: 8,
      title: 'Samsung z flip',
      href: '#',
      price: '$35',
      image: zflip,
      imageAlt: '',
      cart: 'Add to cart',
      
    },
    {
      id: 9,
      title: 'Xiaomi 14t',
      href: '#',
      price: '$35',
      image: xiaomi14t,
      imageAlt: '',
      cart: 'Add to cart',
      
  },
    {
      id: 10,
      title: 'Xiaomi 9c',
      href: '#',
      price: '$35',
      image: xiaomi9c,
      imageAlt: '',
      cart: 'Add to cart',
      
  },
    {
      id: 11,
      title: 'Infinix hot 10',
      href: '#',
      price: '$35',
      image: infinixhot10,
      imageAlt: '',
      cart: 'Add to cart',
      
  },
    {
      id: 12,
      title: 'Infinix smart 6',
      href: '#',
      price: '$35',
      image: infinixsmart6,
      imageAlt: '',
      cart: 'Add to cart',
      
  },
    
    {
      id: 16,
      title: 'Bang and olufsen',
      href: '#',
      price: '$35',
      image: bangandolufsen,
      imageAlt: '',
      cart: 'Add to cart',
      
  },
    
   
  // More products...
]


        export default productsData;